/**
 * Airports the game ships with. Display names live here because the openScope files carry
 * only radio callsigns. Airport JSON is fetched once and shared by every screen.
 */
import { parseOpenScopeAirport, parseOsmGroundNetwork, type AirportData } from '@atc/core';

export interface AirportEntry {
  /** Lower-case ICAO code, also the data folder name. */
  icao: string;
  name: string;
  city: string;
}

export const AIRPORTS: readonly AirportEntry[] = [
  { icao: 'ksfo', name: 'San Francisco International', city: 'San Francisco, United States' },
  { icao: 'llbg', name: 'Ben Gurion', city: 'Tel Aviv, Israel' },
];

export const airportEntry = (icao: string): AirportEntry | undefined => AIRPORTS.find((a) => a.icao === icao.toLowerCase());

const cache = new Map<string, Promise<AirportData>>();

export function loadAirport(icao: string): Promise<AirportData> {
  const key = icao.toLowerCase();
  let p = cache.get(key);
  if (!p) {
    p = Promise.all([
      fetch(`/data/${key}/airport.json`).then((r) => { if (!r.ok) throw new Error(`No airport data for ${key.toUpperCase()} (HTTP ${r.status})`); return r.json(); }),
      fetch(`/data/${key}/osm.geojson`).then((r) => r.ok ? r.json() : null).catch(() => null),
    ]).then(([raw, osm]) => {
      const airport = parseOpenScopeAirport(raw);
      if (osm) airport.groundNetwork = parseOsmGroundNetwork(airport, osm);
      return airport;
    });
    p.catch(() => cache.delete(key));
    cache.set(key, p);
  }
  return p;
}
